/**
 * @file common.ts
 * @author Rapoo Device SDK Team
 * @date 2026-01-29
 * @description VTNrf54L系列设备通用方法
 */
import { ProtocolConfig } from '../../../types/protocol'
import { CMD_VT_CH584, PROTOCOL_CONFIG_VT_CH584 } from '../protocols/cmd'
import { createCheckACK, createSendRead, createSendWrite } from '../../../utils/common'

const protocolConfig: ProtocolConfig = {
  reportId: PROTOCOL_CONFIG_VT_CH584.report_id,
  featureReportId: PROTOCOL_CONFIG_VT_CH584.feature_report_id,
  busy_ack_value: PROTOCOL_CONFIG_VT_CH584.busy_ack_value,
  read_ack_value: PROTOCOL_CONFIG_VT_CH584.read_ack_value,
  readCmd: CMD_VT_CH584.read_eeprom,
  writeCmd: CMD_VT_CH584.write_eeprom,
}
export const checkACK = createCheckACK(protocolConfig)
export const sendRead = createSendRead(protocolConfig)
export const sendWrite = createSendWrite(protocolConfig)

export const versionFileName = 'version.json'
/** 兼容旧引用：保留常量导出（默认国内 URL）。新代码请使用 `device.getFirmwareBaseUrl()`。 */
export const upgradeBaseUrl = 'https://soft.rapoo.com/RapooDriver/Firmware'

/**
 * chipID -> Dongle 型号映射表
 *
 * chipID 是 MasterControl(Nordic) 芯片的类型标识，仅用于无线模式下根据
 * 设备实际返回的 chipID 匹配对应的 Dongle 型号（同一型号鼠标可能搭配不同接收器）。
 * WCH 不参与此匹配。
 */
export const DONGLE_MODEL_MAP: Record<number, string> = {
  5: 'Dongle_NordicL5',
  10: 'Dongle_NordicL10',
  15: 'Dongle_NordicL15',
  20: 'Dongle_NordicLM20',
  120: 'Dongle_NordicH20',
}
